 import FlowEditor from "./FlowEditor";
 
export default function WorkflowBuilder() {
 return <FlowEditor/>;
}
